import React, { useEffect } from 'react'
import { Col, Container, Row } from 'react-bootstrap'
import CardStyle from '../../Components/cards/CardStyle'
import { useLocation } from 'react-router-dom'
import LandscapeThumbnailCard from '../../Components/cards/LandscapeThumbnailCard'
import { useSelector } from 'react-redux'

function EpisodeList() {
    const location = useLocation()
    const episodes=  location?.state[0];
    const projectInfo = useSelector((state) => state?.projectInfo?.value);

    useEffect(()=>{
      window.scroll(0,0)
    },[])
  return (
    <div className='episodeListPage'>
        <div className="wrapper">
        <h2 className='title'>{location?.state[1]}</h2>
        <div className="section-padding">
                <Container fluid>
                  <div className="card-style-grid ">
                    <Row className={` ${projectInfo?.projectConfig?.config?.THUMBNAIL_ORIENTATION === "PORTRAIT" ? 'row row-cols-xl-7 row-cols-md-6 row-cols-sm-4 row-cols-2 row' : 'row-cols-xl-4 row row-cols-md-4 row-cols-sm-3 row-cols-1'}`}>
                      {episodes?.map((item, index) => (
                        <Col key={index} className="mb-4" >
                          <div>
                            {projectInfo?.projectConfig?.config?.THUMBNAIL_ORIENTATION === "PORTRAIT" ? <CardStyle
                              image={item?.thumbnail}
                              title={item?.show_name || item?.video_title}
                              movieTime={item?.duration_text}
                              link={`/videos/${item?.vanity_url}`}
                              show_Id={item?.show_id}
                              vanity_url={item?.vanity_url}
                            />
                            :
                            <LandscapeThumbnailCard
                              image={item?.thumbnail_350_200}
                              title={item?.show_name || item?.video_title}
                              movieTime={item?.duration_text}
                              link={`/videos/${item?.vanity_url}`}
                              show_Id={item?.show_id}
                              vanity_url={item?.vanity_url}
                              data={episodes}
                            />
                          }
                          </div>
                        </Col>
                      ))}
                    </Row>
                  </div>
                </Container>
              </div>
        </div>
    </div>
  )
}

export default EpisodeList